<script setup lang="ts">
const props = defineProps<{
  type: "prev" | "next";
  post: PostItem;
}>();

const { getPostTypeLabel, getPostLink } = usePosts();
const { isMobile } = useUserDevice();
</script>

<template>
  <NuxtLink
    v-if="post?.type && post?.slug"
    :to="getPostLink(post.type, post.slug)"
    class="post-navigation-button min-w-0 max-w-full"
    :title="type === 'prev' ? 'Poprzedni wpis' : 'Następny wpis'"
  >
    <div
      class="post-navigation-button__wrapper flex flex-col-reverse lg:flex-row lg:items-end lg:gap-4"
      :class="{
        'lg:flex-row-reverse items-end': type === 'prev',
        'items-start': type === 'next',
      }"
    >
      <div
        class="post-navigation-button__type text-xs leading-[0.875rem] h-[1.1875rem] text-white whitespace-nowrap contrast-fix"
      >
        {{ props.post?.type ? getPostTypeLabel(props.post.type) : "" }}
      </div>

      <div
        class="post-navigation-button__content flex items-center gap-2 lg:gap-6 min-w-0 max-w-full"
        :class="{ 'flex-row-reverse': type === 'prev' }"
      >
        <div
          class="post-navigation-button__label text-[1.375rem] leading-[1.85625rem] whitespace-nowrap text-ellipsis min-w-0 overflow-hidden"
        >
          {{ post.title }}
        </div>

        <div class="post-navigation-button__icon">
          <template v-if="isMobile">
            <Icon
              :name="type === 'prev' ? 'ns:arrow-left' : 'ns:arrow-right'"
              class="block w-6 h-6"
            />
          </template>

          <svg
            v-else
            width="41"
            height="12"
            viewBox="0 0 41 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-10 h-auto"
          >
            <path
              v-if="props.type === 'prev'"
              d="M0.469669 5.46967C0.176777 5.76256 0.176777 6.23743 0.469669 6.53033L5.24264 11.3033C5.53553 11.5962 6.01041 11.5962 6.3033 11.3033C6.59619 11.0104 6.59619 10.5355 6.3033 10.2426L2.06066 6L6.3033 1.75736C6.5962 1.46446 6.5962 0.98959 6.3033 0.696696C6.01041 0.403803 5.53553 0.403803 5.24264 0.696696L0.469669 5.46967ZM41 5.25L1 5.25L1 6.75L41 6.75L41 5.25Z"
              fill="black"
            />

            <path
              v-else
              d="M40.5303 6.53033C40.8232 6.23743 40.8232 5.76256 40.5303 5.46967L35.7574 0.696696C35.4645 0.403803 34.9896 0.403803 34.6967 0.696696C34.4038 0.98959 34.4038 1.46446 34.6967 1.75736L38.9393 6L34.6967 10.2426C34.4038 10.5355 34.4038 11.0104 34.6967 11.3033C34.9896 11.5962 35.4645 11.5962 35.7574 11.3033L40.5303 6.53033ZM6.55671e-08 6.75L40 6.75L40 5.25L-6.55671e-08 5.25L6.55671e-08 6.75Z"
              fill="black"
            />
          </svg>
        </div>
      </div>
    </div>
  </NuxtLink>
</template>
